import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 336px;
  overflow-y: auto;
  padding-right: 8px;

  scrollbar-gutter: stable;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${ColorV2.Blue7};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${ColorV2.Blue6};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${ColorV2.Blue5};
  }
`;

export const Radio = styled.input`
  width: 18px;
  height: 18px;
  accent-color: ${ColorV2.Blue1};
`;

export const ListDescription = styled.p`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1}
`;

export const ReplaceLoader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 24px 0;
`;

export const ReplaceSpinner = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 3px solid ${ColorV2.Blue6};
  border-top-color: ${ColorV2.Blue1};
  animation: replaceSpin 0.8s linear infinite;

  @keyframes replaceSpin {
    to {
      transform: rotate(360deg);
    }
  }
`;
